'use strict';

module.exports = Object.freeze({
  block: 'block',
  error: 'error',
  warn: 'warn',
});